import React, { Component } from "react";
import AppContext from "../../../contexts/AppContext";

class DeleteModel extends Component {
    constructor(props) {
        super(props);
        this.state = {
            item: {
                delete_type : ""
            },
            errors: {},
           
        };
    }
    handleValidation(){
        let fields = this.state.item;
        let errors = {};
        let formIsValid = true;      
        
        if(!fields.delete_type){
            formIsValid = false;
            errors.delete_type = "Please select delete type.";
        }        

        this.setState({errors: errors});
        return formIsValid;
    }
    delete = () => {   
        if(this.handleValidation()){
            return this.props
                .delete(this.state.item)
                .then(res => {
                    this.props.hideDelete();
                })
                .catch(error => {
                    switch (error.response.status) {
                        case 422:
                            this.setState({ errors: error.response.data.error });
                            break;
                        default:
                            this.context.state.handelError(error);
                            break;
                    }
                });
        }   
        
    };

    onRadioChanged(field) {
        let temp = this.state.item;
        temp[field.target.name] = field.target.value;

        let error = this.state.errors;
        error[field.target.name] = null;

        this.setState({ item: temp, errors: error });
    }

    render() {
        return (
            <div className="model-container model-center model-backdrop-show">
                <div
                    aria-labelledby="model-title"
                    aria-describedby="model-content"
                    className="model-popup model-modal model-show"
                    role="dialog"
                    aria-live="assertive"
                    aria-modal="true"
                >
                    <div className="model-header">
                        <img src="/images/deleteModal.png" alt=""></img>
                    </div>
                    <h2 className="model-title" id="model-title">
                        Delete record
                    </h2>
                    <div className="model-content">
                        <div
                            id="model-content"
                            className=" text-center model-html-container"
                        >
                            Are you sure you want to delete this record?                          
                                    <br/>
                                    <label className="radio-inline deleteRadio">
                                        <input type="radio" name="delete_type" 
                                            value={`1`}                                        
                                            onChange={this.onRadioChanged.bind(this)} />Permanently Delete
                                    </label>
                                    <label className="radio-inline deleteRadio">
                                        <input type="radio" name="delete_type" 
                                            value={`2`}                                        
                                            onChange={this.onRadioChanged.bind(this)} />Archive
                                    </label>
                                    <label className="radio-inline deleteRadio">
                                        <input type="radio" name="delete_type" 
                                            value={`3`}                                        
                                            onChange={this.onRadioChanged.bind(this)} />Delete + Block
                                    </label>
                                    {this.state.errors.delete_type ? (
                                            <div className="invalid-feedback">
                                                {this.state.errors.delete_type}
                                            </div>
                                        ) : null}
                        </div>
                        <div
                            className="model-validation-message"
                            id="model-validation-message"
                        ></div>
                    </div>
                    <div className="model-actions">
                        <button
                            type="button"
                            className="btn btn-danger"
                            onClick={this.delete}
                        >
                            Delete
                        </button>
                        <button
                            type="button"
                            onClick={this.props.hideDelete}
                            className="btn btn-default"
                        >
                            Close
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}
DeleteModel.contextType = AppContext;
export default DeleteModel;



// WEBPACK FOOTER //
// ./src/components/admin/writers/DeleteModel.js